export const PRIMARY_NAV_HEIGHT = "50px";
export const SECONDARY_NAV_HEIGHT = "40px";
export const FOOTER_HEIGHT = "40px";

export const VIEWER_HEIGHT = `calc(100vh - ${PRIMARY_NAV_HEIGHT} - ${SECONDARY_NAV_HEIGHT} - ${FOOTER_HEIGHT}`;
